import { useEffect, useRef } from "react";

/**
 * Adds .in class to elements with .reveal once they enter viewport.
 * Mounted at the App level. Re-observes on route changes.
 */
export default function useReveal() {
    const observerRef = useRef(null);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const els = document.querySelectorAll(".reveal");
        observerRef.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in");
                        observerRef.current.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
        );
        els.forEach((el) => observerRef.current.observe(el));

        return () => {
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
}
